import styled from 'styled-components'

export const CardWrapper = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['8'],
  marginBottom: theme.space['16'],
  padding: theme.space['16'],
}))

export const ErrorWrapper = styled.p(({ theme }) => ({
  color: theme.colors.red500,
  fontSize: '1.4rem',
  padding: theme.space['8'],
  textAlign: 'center',
}))

export const SubmitWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.space['16'],
}))
